<template>
<nav role="navigation" class="navwrapper">
  <transition-group 
    name="breadcrumbElement" 
    tag="div" appear 
    class="breadv1" v-cloak>
        <div class="breadElement" v-for="(el,index) in breadcrumb" :key="el.ID">
            <template v-if="!el.isRoute">
              <a :href="el.href" v-cloak >
                {{el.text}}
              </a>
            </template>
            <template v-else>
              <RouterLink :to="el.path" v-if="index != breadcrumb.length -1">
                {{ el.text }}
              </RouterLink>
              <a v-cloak v-else>{{ el.text }}</a>
            </template>
        </div>
  </transition-group>
</nav>
</template>

<script>
import { RouterLink } from 'vue-router';

export default {
  props:["breadcrumb"]
}
</script>

<style scoped>
.navwrapper{
    position: absolute;
    left: 0;
    right: 0;
    top: 20px;
}

.brcrumbs{
    margin: 0 0 1rem;
    list-style: none;
    height: 24px;
}

.brcrumbs li{
    float: left;
    color: #0a0a0a;
    cursor: default;
    font-family: Montserrat;
    text-transform: none;
}

.brcrumbs li a {
    color: #a7a5a5;
}

.brcrumbs li:not(:last-child):after{
    position: relative;
    top: 1px;
    margin: 0 .75rem;
    opacity: 1;
    content: "/";
    color: #cacaca;
}

.breadcrumbElement{
    transition: opacity 1.5s;
}

.breadcrumbElement-leave-to{
    opacity: 0;
    transition: opacity 0s;
}

.breadcrumbElement-enter{
    opacity:0;
}

.breadcrumbElement-enter-to{
    opacity: 1;
}

.breadcrumbElement-enter-to{
    transition-delay: .2s;
}

.breadcrumbElement-enter-to+.breadcrumbElement-enter-to{
    transition-delay: .4s;
}

.breadcrumbElement-enter-to+.breadcrumbElement-enter-to+.breadcrumbElement-enter-to{
    transition-delay: .6s;
}

.breadcrumbElement-enter-to+.breadcrumbElement-enter-to+.breadcrumbElement-enter-to+.breadcrumbElement-enter-to{
    transition-delay: .8s;
}
.breadcrumbElement-enter-to+.breadcrumbElement-enter-to+.breadcrumbElement-enter-to+
.breadcrumbElement-enter-to+.breadcrumbElement-enter-to{
    transition-delay: 1s;
}

.breadcrumbElement-leave-active{
    transition-delay: 0s;
    display: none;
}

/*#region novo css*/

.navwrapper{
    position: absolute;
    left: 0;
    right: 0;
    top: 20px;
}

.breadv1{
    display: flex;
    justify-content: center;
    margin: 0 0 1rem;
    /*margin-top: 1.2%;*/
}

.breadv1 .breadElement{
    color: #0a0a0a;
    cursor: default;
    font-family: Montserrat;
    text-transform: none;
    font-size: 15px;
}

.breadv1 .breadElement a{
    color: #a7a5a5;
}

.breadv1 .breadElement:not(:last-child):after {
    position: relative;
    top: 1px;
    margin: 0 .75rem;
    opacity: 1;
    content: "/";
    color: #cacaca;
}

.breadv1 .breadElement{
    transition: opacity 1.5s;
}

.breadv1 .breadElement-leave-to{
    opacity: 0;
    transition: opacity 0s;
}

.breadv1 .breadElement-enter{
    opacity:0;
}

.breadv1 .breadElement-enter-to{
    opacity: 1;
}

.breadv1 .breadElement-enter-to{
    transition-delay: .2s;
}

.breadElement-enter-to+.breadElement-enter-to{
    transition-delay: .4s;
}

.breadElement-enter-to+.breadElement-enter-to+.breadElement-enter-to{
    transition-delay: .6s;
}

.breadElement-enter-to+.breadElement-enter-to+.breadElement-enter-to+.breadElement-enter-to{
    transition-delay: .8s;
}
.breadElement-enter-to+.breadElement-enter-to+.breadElement-enter-to+
.breadElement-enter-to+.breadElement-enter-to{
    transition-delay: 1s;
}

@media (min-width: 768px) and (max-width: 1024px){
    .breadv1{
        font-size: 14px;
    }
}

@media (max-width: 767px){
    .breadv1 .breadElement{
        display: none;
    }
}

.breadv1.whitenav .breadElement a {
    color: white;
}
</style>